import { Box } from "@mui/material";
import { DotLegalDialog } from "@dotlegal/dotlegal-ui-components";
import DetailsWrapper from "../../notification/detailsWrapper/DetailsWrapper";
import { NotificationType } from "../../notification/Notification.types";
import { usePublishedSystemNotificationDialog } from "./PublishedSystemNotificationDialog.hooks";
import { useTranslation } from "../../localization/useTranslation";

function PublishedSystemNotificationDialog() {
    const { systemNotification, showDialog, handleClose } = usePublishedSystemNotificationDialog();
    const { translateString } = useTranslation();

    if (!showDialog || !systemNotification) {
        return null;
    }

    return (
        <DotLegalDialog size="md" buttonOkText={translateString("close")} open onDialogClose={handleClose} onOkClick={handleClose} setCustomHeader>
            <DetailsWrapper
                date={systemNotification.created}
                description={systemNotification.title}
                isProcessingActivityValidation={false}
                notificationType={NotificationType.Release}
            >
                <Box dangerouslySetInnerHTML={{ __html: systemNotification.content }} />
            </DetailsWrapper>
        </DotLegalDialog>
    );
}

export default PublishedSystemNotificationDialog;
